import { render, staticRenderFns } from "./ErrorCatalogs.vue?vue&type=template&id=50af3ed8&lang=pug&"
import script from "./ErrorCatalogs.vue?vue&type=script&lang=js&"
export * from "./ErrorCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports